<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal">
        <section class="modal-body">
          <header class="modal-header">
            <div class="entity-title">{{$t("tournament.addAbsence")}}</div>
          </header>
          <div v-if="actionMessage!=''" class="w3-panel errorBox w3-round">
            {{actionMessage}} <font-awesome-icon class="info w3-right" icon="info-circle" /> 
          </div>
          <div class="inputFields">
            <label>{{ $t('tournament.player') }}</label>
            <select v-model="selectedAbsenceId" class="theme-input">
              <option class="placeholder" value="-1" disabled selected hidden>{{$t("tournament.player")}}</option>
              <option v-for="absence in sortedAbsences" :value="absence.participantId" v-bind:key="absence.participantId">{{absence.person.name}}</option>
            </select>         
            <label>{{ $t('tournaments.reason') }}</label>
            <select  v-model="selectedReasonId" class="theme-input">
              <option value="-1" disabled selected hidden>{{$t("tournament.absenceReason")}}</option>
              <option v-for="score in scores" :value="score.scoreId" v-bind:key="score.scoreId">{{score.name}}</option>
            </select>         
            <ul v-if="(okClicked || afterAddAndNew) && (selectedAbsenceId ==-1 || selectedReasonId == -1)">
              <li v-if="selectedAbsenceId == -1">
                <font-awesome-icon class="text-red" icon="times"/>
                {{$t("tournament.noPlayerSelected")}}
              </li>
              <li v-if="selectedReasonId == -1">
                <font-awesome-icon class="text-red" icon="times"/>
                {{$t("tournament.noReasonSelected")}}
              </li>
            </ul>
            <div class="buttons">
              <button class="button-default" @click="addAndNew">{{ $t('app.actions.addAndNew') }}</button>
            </div>
            <div class="buttons">
              <button class="button-default" @click="ok">{{ $t('app.actions.ok') }}</button>
              <button class="button-default" @click="cancel">{{ $t('app.actions.cancel') }}</button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
const apiName = 'api';

export default {
  name: "AddAbsenceModal",
  props:{ 
    absences: { type: Array, required: false, default: () => [{ participantId: 0, name: "No players provided" }] },
    roundId: String,
    scores: { type: Array, required: false, default: () => [{ scoreId: 0, name: "No scores provided" }] }
  },
  data: function () {
    return {
      actionMessage: "",
      afterAddAndNew: false,
      errorMessage: "",
      reasons: [{reasonId:"1", name:"absent with message"},
                {reasonId:"2", name:"absent without message"},
                {reasonId:"3", name:"absent for club"},
                {reasonId:"4", name:"manual bye"}],
      selectedAbsenceId: "-1",
      selectedReasonId: "-1",
      sortedAbsences: [],
      okClicked: false
    }
  },
  emits: [ 'cancel', 'ok' ],
  beforeMount() {
    this.sortedAbsences = this.sortAbsences();
  },
  methods: {
    addAndNew() {
      this.afterAddAndNew = true;
      if (this.selectedAbsenceId != -1 && this.selectedReasonId != -1) {
        this.saveAbsence(this.selectedAbsenceId, this.selectedReasonId);
      }
    },

    cancel() {
      if (this.afterAddAndNew)
        this.$emit('ok');
      else
        this.$emit('cancel');
    },

    ok() {
      this.okClicked = true;
      console.log("Testabsence 1 " + this.absences.length)
      if (this.selectedAbsenceId != -1 && this.selectedReasonId != -1) {
        this.saveAbsence(this.selectedAbsenceId, this.selectedReasonId);
      }
    },

    saveAbsence(participantId, reasonId) {
      const absenceInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: {"participantId": participantId, "reasonId": reasonId, "roundId": this.roundId, "tournamentId": this.scores[0].tournamentId},
        response: false, 
      };
      let that = this;
      let completePath = '/absence';
      RestAPI
        .post(apiName, completePath, absenceInit)
        .then(response => {
          console.log("Absence added: " + response);
          if (that.okClicked) {
            that.$emit('ok');
          }
          that.actionMessage = "\"" + that.absences.find(a => a.participantId === participantId).person.name 
            + "\"" + this.$t("tournament.absenceAddedAs")  + "\""  
            + that.scores.find(r => r.scoreId === reasonId).name + "\" ";
          that.selectedAbsenceId = -1;
          that.selectedReasonId = -1;
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    sortAbsences() {
      return Array.from(this.absences).sort((a, b) => {
        if (a.person.name < b.person.name) {
          return -1
        }
        if (a.person.name > b.person.name) {
          return 1
        }
        return 0
      })
    },

  }
};


</script>

<style scoped>

.info {
  margin-top: 4px;
  margin-left: 8px;
}

</style>
